import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import BadgeContainer from '../framework/badges/badge_container';
import BadgeDiscount from '../framework/badges/badge-discount';
import BiomarkerAmount from '../framework/biomarker-amount';
import Btn from '../framework/buttons/btn';
import Clickable from '../framework/clickable';
import GroupLink from '../framework/group_link';
import PriceItem from '../shop/price_item';
import Trans from '../translation/trans';
import ProductGroupIcon from './product-group-icon';

const ProductItemList = ({
	currency,
	excerpt,
	group_id,
	groups,
	markers,
	page,
	price,
	price_discount,
	product_default,
	product_id,
	product_image,
	product_variant_id,
	slug,
	subtitle,
	title,
}) => {
	const { t } = useTranslation('component_test_product_list_item_featured');
	const id_key = `product-item-${product_variant_id}-${slug}`;

	{
		/* STATSIG EXPERIMENT
	const { config: experiment, isLoading: isLoadingExperiment } = useExperiment(
		'product_item_featured_cta_text',
	);


	const cta_text = experiment.get('cta_text', DEFAULT_CTA_TEXT);

	const currentAction = useMemo(() => {
		const actions = {
			cta_text_1: {
				buttons: [
					{
						text: 't2',
						url: '/tester/halsokontroller/halsokontroll-stor/',
					},
				],
			},
			cta_text_2: {
				buttons: [
					{
						text: 't3',
						url: '/tester/halsokontroller/halsokontroll-stor/',
					},
				],
			},
			cta_text_3: {
				buttons: [
					{
						text: 't4',
						url: '/tester/halsokontroller/halsokontroll-stor/',
					},
				],
			},
			cta_text_control: {
				buttons: [
					{
						text: 't1',
						url: '/tester/halsokontroller/halsokontroll-stor/',
					},
				],
			},
		};

		let out = null;
		if (actions[cta_text]) out = actions[cta_text];
		return out;
	}, [cta_text]);

	const handleTracking = ({ id, text, type }) => {
		createEvent('button_click', {
			id,
			text,
			type,
		});
	};

	if (!currentAction || isLoadingExperiment) {
		return <></>;
	}
		*/
	}

	return (
		<Clickable id={id_key}>
			<div className="bg-gray-100 mb-3 product-list-item position-relative rounded-3 o-hidden">
				<div className="d-inherit border-0 container">
					<div className="row align-items-center justify-content-between">
						<div className="px-0 col-lg-6 mb-4 mb-lg-0">
							<BadgeContainer position="top_left">
								<BadgeDiscount
									className=""
									price={price}
									price_discount={price_discount}
								/>
							</BadgeContainer>

							{product_image && (
								<>
									<GatsbyImage
										alt={title}
										className="img-fluid product-item-featured-img rounded-4"
										draggable="false"
										image={getImage(product_image)}
									/>
								</>
							)}
							{!product_image && (
								<div className="img-fluid product-item-featured-img align-items-center d-flex px-2 rounded-2">
									<ProductGroupIcon
										alt={title}
										groups={[group_id]}
										type="product_img"
									/>
								</div>
							)}
						</div>

						<div className="col-lg-6 py-2 px-4">
							{subtitle && (
								<div className="list-subtitle  me-1 mb-1 text-break white-space-break">
									{subtitle}
								</div>
							)}
							<div className="">
								<div>
									<div>
										{markers.length > 0 && (
											<span className="me-1">
												<BiomarkerAmount
													color="light"
													count={markers.length}
													groups={
														product_default?.group_id
															? [product_default?.group_id]
															: groups
													}
													product_id={product_id}
													size="xs"
												/>
											</span>
										)}
									</div>
									<h3 className="mb-0 display-inline title-sm text-break white-space-break">
										<GroupLink
											className="clickable text-decoration-none text-dark fw-700  text-break white-space-break"
											groups={
												product_default?.group_id
													? [product_default?.group_id]
													: groups
											}
											page={page}
											product_id={product_id}
										>
											{title}
										</GroupLink>
									</h3>
									<Trans defaults={excerpt} t={t} />
									<div className="price mb-2 mt-lg-2 mt-1">
										<p className="title-medium fw-700 mb-0 text-number">
											<PriceItem
												currency={currency?.code}
												price={price}
												price_discount={price_discount}
											/>
										</p>
									</div>

									<Btn
										className="mb-3"
										color="accent"
										fullWidth
										//onClick={() =>
										//	handleTracking({
										//		id: index,
										//		text: t(item.text),
										//		type: 'product_item_featured_cta',
										//	})
										//}
										rightSection={<ArrowRightShort className="lead ms-2" />}
										size="lg"
									>
										{t('t1')}
									</Btn>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Clickable>
	);
};

ProductItemList.propTypes = {
	currency: PropTypes.object,
	excerpt: PropTypes.string,
	group_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	groups: PropTypes.array,
	markers: PropTypes.array,
	onAddToCart: PropTypes.func,
	page: PropTypes.string,
	price: PropTypes.string,
	price_discount: PropTypes.string,
	product_default: PropTypes.object,
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	product_image: PropTypes.object,
	product_variant_id: PropTypes.number,
	slug: PropTypes.string,
	state: PropTypes.string,
	status: PropTypes.string,
	subtitle: PropTypes.string,
	title: PropTypes.string,
	type: PropTypes.string,
};

export default ProductItemList;
